"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseUrl = void 0;
var baseUrl;
exports.baseUrl = baseUrl;
if (window.hasOwnProperty('COGNITO_BASEURL'))
    exports.baseUrl = baseUrl = COGNITO_BASEURL;
else
    exports.baseUrl = baseUrl = 'https://www.cognitoforms.com';
